export default __webpack_public_path__ + "static/media/strongMan.0dee69d1.png";